module.exports = "<mat-spinner class = \"spin-center\"></mat-spinner>"